module.exports = __webpack_public_path__ + "img/driversLicenseExampleFront.70bb4acf.svg";